import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import AuthRoute from "./Components/AuthRoute";

// Static Imports
import "./Assets/css/App.css";
import "./Assets/css/MUI-Overloads.css";

// Main Pages
import Login from "./Pages/MainPages/LoginPage/Login";
import Home from "./Pages/MainPages/HomePage/Home";
import OrderSearch from "./Pages/MainPages/OrderSearchPage/OrderSearch";
import OrderProcess from "./Pages/MainPages/OrderProcessPage/OrderProcess";
import Leads from "./Pages/MainPages/LeadsPage/Leads";
import OptOut from "./Pages/MainPages/OptOutPage/OptOut";
import SelfOptOut from "./Pages/MainPages/SelfOptOutPage/SelfOptOut";
import Customer from "./Pages/MainPages/CustomerPage/Customer";
import Influencer from "./Pages/MainPages/InfluencerPage/Influencer";
import OptOutBlacklist from "./Pages/MainPages/OptOutBlacklist/OptOutBlacklist";
import OptOutWhitelist from "./Pages/MainPages/OptOutWhitelist/OptOutWhitelist";

// Error Pages
import Four from "./Pages/ErrorPages/404";
import SlidingMenuBar from "./Components/SlidingMenuBar";

const App = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [toggledMenu, setToggledMenu] = useState(false);
  const [nodeEnv, setNodeEnv] = useState("");

  const auth = useSelector(({ auth }) => auth);
  const userIsAuthenticated = () => auth && auth.userInfo && auth.userInfo.isAuth;

  useEffect(() => {
    const handleSidebarToggle = (e) => {if (e.key === "/") setIsOpen(!isOpen)};
    getEnv();
    document.body.addEventListener("keydown", handleSidebarToggle);
    return () => document.body.removeEventListener("keydown", handleSidebarToggle)
  }, [isOpen, nodeEnv]);

  const getEnv= async () => {
    const request = await fetch("/api/env");
    const { env } = await request.json();
    setNodeEnv(env);
    localStorage.setItem("NODE_ENV", env || "development");
  }
  return (
    <Router>
      { userIsAuthenticated() &&
      <SlidingMenuBar
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        toggledMenu={toggledMenu}
        setToggledMenu={setToggledMenu}
      /> }
      <Routes>
        <Route exact path="/" element={<Login isOpen={isOpen} />} />
        <Route exact path="/Home" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={Home}
          />} />
        <Route exact path="/Customer/:id" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={Customer}
          />} />
        <Route exact path="/Search" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={OrderSearch}
          />} />
        <Route exact path="/OptOut" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={OptOut}
          />} />
        <Route exact path="/SelfOptOut" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={SelfOptOut}
          />} />
        { nodeEnv !== 'production' &&
        <Route exact path="/Order" element={
           <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={OrderProcess}
          />} />
        }
        <Route exact path="/Leads" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={Leads}
          />} />
        <Route exact path="/Influencer" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={Influencer}
          />} />
        <Route exact path="/ManageOptOutBlacklist" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={OptOutBlacklist}
          />} />
        <Route exact path="/ManageOptOutWhitelist" element={
          <AuthRoute
            auth={auth}
            isAuth={userIsAuthenticated()}
            isOpen={isOpen}
            Component={OptOutWhitelist}
          />} />
        <Route exact path="/*" element={<Four isOpen={isOpen} />} />
      </Routes>
    </Router>
  );
};
export default App;
